import * as React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { ImagesContext } from "../../Context";
import { SecondaryInsuranceType } from "../types";
import { formatZip } from "../../utils/StringHelper";
import moment from "moment";

interface SecondaryInsuranceInfoProps {
  secondaryInsurance: SecondaryInsuranceType | null;
  handleSetEditing: () => void;
  claimStatus: string;
}

const SecondaryInsuranceInfo: React.FC<SecondaryInsuranceInfoProps> = ({
  secondaryInsurance,
  handleSetEditing,
  claimStatus,
}) => {
  const images = React.useContext(ImagesContext);

  return (
    <Box className="info-container">
      <Grid container>
        <Grid item xs={4}>
          <Typography className="info-heading-label">
            Insurance Information
          </Typography>
          <Typography className="info-heading-text">
            Insurance Type: {secondaryInsurance?.insurance_type}
            <br />
            Program or Plan Name: {secondaryInsurance?.plan_name}
            <br />
            Insurance Number: {secondaryInsurance?.insurance_number}
          </Typography>
        </Grid>

        <Grid item xs={3}>
          <Typography className="info-heading-label">
            Insured’s Name (Last, First, Middle)
          </Typography>
          <Typography className="info-heading-text">
            <>
              {secondaryInsurance?.last_name}
              <br />
              {secondaryInsurance?.first_name}
              <br />
              {secondaryInsurance?.middle_name}
            </>
          </Typography>
        </Grid>

        <Grid item xs={2}>
          <Typography className="info-heading-label">Address</Typography>
          <Typography className="info-heading-text">
            <>
              {secondaryInsurance?.address_line_1}{" "}
              {secondaryInsurance?.address_line_2 &&
                `, ${secondaryInsurance?.address_line_2}`}
              <br />
              {secondaryInsurance?.city}
              {secondaryInsurance?.city && ","} {secondaryInsurance?.state}{" "}
              {formatZip(secondaryInsurance?.zip)}
              <br />
            </>
          </Typography>
        </Grid>

        <Grid item xs={2}>
          <Typography className="info-heading-label">
            Additional Details
          </Typography>
          <Typography className="info-heading-text">
            <>
              DOB:{" "}
              {moment(secondaryInsurance?.insured_dob).format("MM/DD/YYYY")}
              <br />
              Sex: {secondaryInsurance?.gender}
              <br />
              Patient’s Relationship to Insured:{" "}
              {secondaryInsurance?.relationship}
            </>
          </Typography>
        </Grid>
        {claimStatus !== "submitted" &&
          claimStatus !== "pending_submission" && (
            <Grid item xs={1} display="flex" justifyContent="flex-end">
              <div className="item-icon-container" onClick={handleSetEditing}>
                <img
                  src={images.pencil_orange_icon}
                  alt="edit patient Icon"
                  className="action-icon-image"
                  style={{ width: 23, maxHeight: 23 }}
                />
              </div>
            </Grid>
          )}
      </Grid>
    </Box>
  );
};

export default SecondaryInsuranceInfo;
